<template>
    <div style="box-sizing: border-box;padding: 47px 70px;">
        <div v-if="cur == 1">
            <div class="par1 flx alc jsb">
                <el-upload class="upload-demo" style="width: 100%;" action="https://hrxsl.com/api/Common/oss_upload"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="uploadHeaders"
                    :show-file-list="false">
                    <div class="useravatar">
                        <img :src="$img(form1.avatar)" alt="" />
                    </div>
                </el-upload>
            
                <el-button type="primary" @click="comple">完成</el-button>
            
            </div>
            <div class="par2 flx alc jsb">
                <div class="paleft flx alc">
                    昵称:
                    <div class="inpss">
                        <el-input placeholder="请输入内容" v-model="form1.nickname" clearable>
                        </el-input>
                    </div>
            
                </div>
                <div class="paright flx alc">
                    性别:
                    <div style="margin-left: 10px;">
                        <el-radio v-model="form1.sex" label="1">男</el-radio>
                        <el-radio v-model="form1.sex" label="2">女</el-radio>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="par1 flx alc jsb">
                <div class="useravatar">
                    <img :src="$img(form.avatar)" alt="" />
                </div>
                <el-button @click="cur = 1" type="info">编辑＞</el-button>
            
            </div>
            <div class="par2 flx alc jsb">
                <div class="paleft flx alc">
                    昵称:
                    <div class="inpss" v-text="form.nickname">
                        
                    </div>
            
                </div>
                <div class="paright flx alc">
                    性别:
                    <div style="margin-left: 10px;" v-text="form.sex == '1'?'男' : '女'">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        edituser,
        userInfo
    } from "@/api/index.js"
    export default {
        name: 'userinfo',
        data() {
            return {
                cur:0,
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
                form: {
                    avatar: "",
                    nickname: "",
                    sex: ""
                },
                form1: {
                    avatar: "",
                    nickname: "",
                    sex: ""
                }

            }
        },
        mounted() {
            let that = this
            that.getuser()
        },
        methods: {
            comple(){
                let that = this 
                let data = {}
                data.nickname = that.form1.nickname
                data.avatar = that.form1.avatar
                data.sex = that.form1.sex
                edituser(data).then((res) => {
                    if(res.code == 1){
                        that.$message.success(res.msg)
                        that.getuser()
                        that.cur = 0
                         that.$emit("refr",33321)
                    }else{
                        that.$message.error(res.msg)
                    }
                })
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 3 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }

                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }

                // 校验通过，允许上传
                return true
            },
            getuser() {
                let that = this
                userInfo().then((res) => {
                    if (res.code == 1) {
                        console.log(res)
                        if (res.code == 1) {
                            that.form.avatar = res.data.avatar
                            that.form.nickname = res.data.nickname
                            that.form.sex = res.data.sex
                            that.form1.avatar = res.data.avatar
                            that.form1.nickname = res.data.nickname
                            that.form1.sex = res.data.sex+''
                        }
                    }
                })
            },
            handleAvatarSuccess(e) {
                let that = this
                console.log(e)
                if (e.code == 1) {
                    let data = {}
                    data.avatar = e.data.url
                    edituser(data).then((res) => {
                        if(res.code == 1){
                             that.avatar = res.data.avatar
                             that.getuser()
                             // console.log(3321)
                            
                             // history.go(0)
                        }
                    })
                } else {
                    that.$message.error(e.msg)
                }

            },
        }
    }
</script>

<style scoped>
    .par2{
        margin-top: 31px;
        font-size: 14px;
        color: #77798D;
    }
    .inpss {
        width: 254px;
        margin-left: 10px;
    }

    .useravatar {
        width: 78px;
        height: 78px;
    }

    .useravatar img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
</style>